"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatBp = void 0;
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns props `value` formatted as the BP.
 * @see {@link useFormatBp} for more information.
 *
 * @see {@link FormatBpProps} for the available props.
 * @example
  // basic usage
  <FormatBp value={1234.567} />
 */
const FormatBp = ({
  children,
  value
}) => {
  const formattedValue = (0, _hooks.useFormatBp)(value ?? children);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: formattedValue
  });
};
exports.FormatBp = FormatBp;
//# sourceMappingURL=FormatBp.js.map